export default __webpack_public_path__ + "static/media/man_united.55cde211.png";